import { Form } from 'antd';
import styled from 'styled-components';

export const Label = ({
  label,
  tooltip,
  required,
  marginTop,
  children,
  onChange,
  layout,
  wide,
  bold,
  colon
}) => {
  return (
    <StyledLabel
      label={label}
      layout={layout}
      tooltip={tooltip}
      required={required}
      colon={colon}
      $marginTop={marginTop}
      $wide={wide}
      $bold={bold}
      onChange={onChange}
    >
      {children}
    </StyledLabel>
  );
};

const StyledLabel = styled(Form.Item)`
  ${({ $marginTop }) => $marginTop && `margin-top:${$marginTop}px;`};
  ${({ $wide }) => ($wide ? 'width: 100%' : '')};
  margin-bottom: unset;
  label {
    font-size: 14px !important;
    ${({ $bold }) => ($bold ? 'font-weight: 700' : '')};
    line-height: 150% !important;
    color: #27272a !important;
    position: relative !important;
  }
  label.ant-form-item-required::before {
    margin-inline-end: unset !important;
    position: absolute !important;
    right: 0 !important;
    /* right: -15px !important; */
  }
`;
